import {useMemo} from 'react';
import type {GetEntryManagementsResponse} from '../../../core/repositories/mypageEntryManagementsRepository';

type UseCompanySearchProps = {
  /** 全エントリー管理データ（企業名リスト抽出用） */
  allData?: GetEntryManagementsResponse;
  /** API検索結果データ（企業名でフィルタリング済み） */
  searchData?: GetEntryManagementsResponse;
  /** ページングされた表示用データ（企業名検索がない場合に使用） */
  paginatedData?: GetEntryManagementsResponse;
  /** 現在の企業名検索ワード */
  companySearchWord: string;
};

/**
 * 企業名検索機能を提供するカスタムフック（ハイブリッドアプローチ）
 *
 * @description
 * - 企業名リスト: 全データから抽出（Select用）
 * - 表示データ: API検索結果を使用（企業選択時）または全データ（未選択時）
 */
export const useCompanySearch = ({
  allData,
  searchData,
  paginatedData,
  companySearchWord,
}: UseCompanySearchProps) => {
  const companyList = useMemo(() => {
    if (!allData) return [];
    return Array.from(
      new Set(allData.entries.map((entry) => entry.companyName)),
    ).sort();
  }, [allData]);

  const displayEntries = useMemo(() => {
    if (companySearchWord && searchData) {
      return searchData.entries;
    }
    // ページングデータがある場合はそれを使用、なければ全データ
    return paginatedData?.entries ?? allData?.entries ?? [];
  }, [companySearchWord, searchData, paginatedData, allData]);

  return {
    companyList,
    displayEntries,
  };
};
